import moment from "moment";
import { STORAGE_KEYS } from "./config";
import { getBranch, getMenu } from "../pages/api/hello";
import { getGeneralSetting, getGeneralSetting_WorkingTime, getWorkingTime } from "../pages/api/cart";

const timerRefresh = 300;

export async function loadStorage(key_name:string){
    let value = null;
    let obj:any = localStorage.getItem(key_name);
    if(obj){
        obj = JSON.parse(obj);
        let startDate = moment(obj.timestamp).add(timerRefresh, 'seconds');
        let now = moment(new Date().getTime());
        if(startDate.isAfter(now)){
            value = await obj.value;
        }
    }
    return value;
}

export async function setStorage(key_name:string, res:any){
    try{
        await localStorage.removeItem(key_name);
        var object = {value: res, timestamp: new Date().getTime()};
        await localStorage.setItem(key_name, JSON.stringify(object));
    }
    catch(e:any){

    }
}

export const getMenuStorage = async () => {
    return await loadStorage(STORAGE_KEYS.DATA_MENU);
}

export const loadMenu = async () => {
    try {
      let arr_menu = await loadStorage(STORAGE_KEYS.DATA_MENU);
    //   console.log("menuStorage: ",arr_menu);
      if(!arr_menu){
        let res: any = await getMenu();
        if (res) {
            setStorage(STORAGE_KEYS.DATA_MENU, res)
            arr_menu=res;
        }
        // let res: any = await getMenuParent();
        // if (res) {
        //     let res1: any = await getMenu_ProductCategory();
        //     console.log(res1);
        //     if (res1) {
        //         let temp = res.find((x:any)=>x.type == 1);
        //         console.log(temp.children);
        //         if(temp)
        //             temp.children.push.apply(temp.children, res1);
        //     }
        //     console.log(res);
        //     setStorage(STORAGE_KEYS.DATA_MENU, res)
        //     arr_menu=res;
        // }
      }
      return arr_menu;
      
    } catch (error) {
      return [];
    }
}

export const loadSystemSetting_WorkingTime = async () => {
    try {
        let arr = await loadStorage(STORAGE_KEYS.DATA_SETTING_WORKINGTIME);
        if (!arr) {
            await getGeneralSetting_WorkingTime().then((res) => {
                if (res) {
                    setStorage(STORAGE_KEYS.DATA_SETTING_WORKINGTIME, res);
                    arr = res;
                }
            });
        }
        return arr;
    } catch (error) {
      return [];
    }
}

export const loadSystemSetting = async () => {
    try {
        let arr = await loadStorage(STORAGE_KEYS.DATA_SETTING);
        if (!arr) {
            await getGeneralSetting().then((res) => {
                if (res) {
                    setStorage(STORAGE_KEYS.DATA_SETTING, res);
                    arr = res;
                }
            });
        }
        return arr;
    } catch (error) {
      return [];
    }
}

export const loadBranchs = async () => {
    try {
        let arr = await loadStorage(STORAGE_KEYS.DATA_BRANCHS);
        if (!arr) {
            await getBranch().then((res:any) => {
                if (res) {
                    setStorage(STORAGE_KEYS.DATA_BRANCHS, res.results ?? []);
                    arr = res.results;
                }
            });
        }
        return arr;
    } catch (error) {
      return [];
    }
}

export const loadWorkingTime = async () => {
    try {
        let arr = await loadStorage(STORAGE_KEYS.DATA_WORKINGTIME);
        if (!arr) {
            await getWorkingTime().then((res:any) => {
                if (res) {
                    setStorage(STORAGE_KEYS.DATA_WORKINGTIME, res);
                    arr = res;
                }
            });
        }
        return arr;
    } catch (error) {
      return [];
    }
}